import Record from './base'
import moment from 'moment'

export class Purchase extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
    this.orderableDate = moment(
      this.purchase_time,
      'YYYY-MM-DD HH:mm:ss'
    ).valueOf()
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/purchase.js